import InputField from "@_common/InputRuleFeild";
import {
  convertCurrentDate,
  convertCurrentDateWithTime,
  convertDate,
} from "@_common/date-helpers";
import {
  concatDotToDocumentString,
  concatDotToString,
  getEncodedKey,
} from "@_common/text-helpers";
import { getValue } from "@utils/lodash";
import React, { useEffect, useState } from "react";
import { formatString, getFirstLetter } from "@_common/format-text";
import DragAndDropFileComponent from "@_common/file-drag-drop";
import {
  downloadURL,
  GetSpecificOrganizationToken,
} from "@services/auth.service";
import { saveAs } from "file-saver";
import { Alert } from "reactstrap";
import { toast } from "react-toastify";
import CautionSvgComponent from "../../../assets/svg-components/caution";
import { formatDate } from "@_common/format-date";
import moment from "moment";
import { sanitizeInput } from "@_common/dompurify";
import { canShowMarkCompleted } from "@_common/task-status";

function SelfComplianceUpdatePopup(props: any) {
  const {
    showUpdatePopup,
    setShowUpdatePopup,
    selfCompliance,
    setSelfCompliance,
    handleUploadDocuments,
    handleSubmitTask,
    submitLoading,
    selectedStatus,
    selectedObj,
    removeDocument,
    handleDrop,
    uploadLoading,
    handleDragOver,
    disableUpload,
    inside,
    handleUpdateUploadDocuments,
    updateUploadLoading,
    showUploadUpdate,
    handleChangeUpdateStatus,
    statusLoading,
    showAuditorComment,
    handleModalAC,
    handleUploadSubmitTask,
    handleUpdateUploadDocumentsSubmit,
    interlinkedTaskList,
    selectedIDs,
  } = props;
  const canUpdate =
    getValue(props, `permissions`, []).includes("update") ||
    getValue(props, `permissions`, []).includes("bulk_update");
  const [selectedInterlinkedTaskIds, setSelectedInterlinkedTaskIds] = useState<
    string[]
  >([]);

  const handleCheckboxChange = (taskId: string) => {
    setSelectedInterlinkedTaskIds((prev) =>
      prev.includes(taskId)
        ? prev.filter((id) => id !== taskId)
        : [...prev, taskId],
    );
  };

  useEffect(() => {
    if (interlinkedTaskList && interlinkedTaskList.length) {
      setSelectedInterlinkedTaskIds((prev) => [...prev, selectedObj.id]);
    }
  }, [interlinkedTaskList, selectedObj.task_id]);

  const [complianceStatusList] = useState([
    { value: "POSING", label: "Posing" },
    { value: "PENDING", label: "Pending" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "DELAYED", label: "Delayed" },
    { value: "DELAYED_REPORTED", label: "Delay Reported" },
    { value: "NOT_APPLICABLE", label: "Not Applicable" },
    { value: "PENDING_FOR_APPROVAL", label: "Pending For Approval" },
    { value: "RE_OPENED", label: "Re Opened" },
    { value: "WORK_IN_PROGRESS", label: "Work In Progress" },
    { value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
    { value: "ASSIGNED", label: "Assigned" },
    { value: "AWAITING_APPROVAL", label: "Awaiting Approval" },
    {
      value: "REPORTED_NON_COMPLIED",
      label: "Reported Non Complied",
    },
  ]);
  // Complied
  const checkCompiled = () => {
    if (
      getValue(selectedIDs, "length", 0) > 1 &&
      getValue(props, "list.length", 0) > 0
    ) {
      const selectedTasks = props.list.filter((item: any) =>
        selectedIDs.includes(getValue(item, "id", ""))
      );
      if (selectedTasks.length > 0) {
        return selectedTasks.every((item: any) =>
          canShowMarkCompleted(getValue(item, "compliance_status", ""))
        );
      }
    }
    const status =
      getValue(selfCompliance, `compliance_status`, "") ||
      getValue(selectedObj, `compliance_status`, "");
    return canShowMarkCompleted(status);
  };
  // approved, Reopen
  const checkApprover = () => {
    return (getValue(selfCompliance, `compliance_status`, "") === "COMPLIED" ||
      getValue(selfCompliance, `compliance_status`, "") === "DELAYED" ||
      getValue(selfCompliance, `compliance_status`, "") ===
        "EVENT_NOT_OCCURED" ||
      getValue(selfCompliance, `compliance_status`, "") ===
        "AWAITING_APPROVAL" ||
      getValue(selfCompliance, `compliance_status`, "") ===
        "DELAYED_REPORTED") &&
      getValue(selectedObj, `approval_status`, "") === "PENDING"
      ? true
      : false;
  };

  const [isLoading, setIsLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState<any>(null);
  const [isBelowMinDate, setIsBelowMinDate] = useState(false);
  const [minDateErrorMessage, setMinDateErrorMessage] = useState("");
  const [configuredCompletionDate, setConfiguredCompletionDate] =
    useState(null);
  const [futureDateCompletionLimit, setFutureDateCompletionLimit] =
    useState<number | null>(null);
  const [isCompletionDateEditable, setIsCompletionDateEditable] =
    useState(false);
  const [autoPopulateSelfComplianceCompletionDate, setAutoPopulateSelfComplianceCompletionDate] =
    useState<boolean>(true);
  const handleDownloadOnClick = async (
    url: string,
    name: string,
    index: number,
  ) => {
    try {
      setSelectedIndex(index);
      setIsLoading(true);
      let resp = await downloadURL(getEncodedKey(url));
      if (resp) {
        let url = getValue(resp, `data.url`, "")
          ? getValue(resp, `data.url`, "").includes("https://")
            ? getValue(resp, `data.url`, "")
            : `https://${getValue(resp, `data.url`, "")}`
          : getValue(resp, `data.url`, "");
        saveAs(url, name);
        setIsLoading(false);
        setSelectedIndex(null);
      } else {
        setIsLoading(false);
        setSelectedIndex(null);
      }
    } catch (error) {
      setIsLoading(false);
      setSelectedIndex(null);
    }
  };

  const getData = async (id: string, token: string) => {
    try {
      let resp = await GetSpecificOrganizationToken(id, token);
      const compDate =
        resp.data.data.self_compliance_completion_backdate_limit_days;
      setConfiguredCompletionDate(compDate === "{}" ? null : compDate);
      const futureDateLimit =
        resp.data.data.sc_future_date_completion_days_limit;
      setFutureDateCompletionLimit(
        futureDateLimit === "{}" ||
          futureDateLimit === null ||
          futureDateLimit === undefined ||
          futureDateLimit === ""
          ? null
          : Number(futureDateLimit),
      );
      const completionDateEditable = getValue(
        resp,
        "data.data.is_completion_date_editable",
        false,
      );
      setIsCompletionDateEditable(
        completionDateEditable === true || completionDateEditable === "true",
      );
      setSelfCompliance((prev: any) => ({
        ...prev,
        is_required_reason_for_non_compliance: getValue(
          resp,
          "data.data.is_required_reason_for_non_compliance",
          false,
        ),
      }));

      const autoPopulate =
        resp.data.data.auto_populate_self_compliance_completion_date;
      setAutoPopulateSelfComplianceCompletionDate(autoPopulate ?? true);
    } catch (error) {}
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken") || "";
    const orgId =
      localStorage.getItem("user") &&
      JSON.parse(String(localStorage.getItem("user")))?.org_id;
    getData(orgId, accessToken);
  }, []);

  const hasKey = (data: any, key: string) => {
    return (
      getValue(data, `length`, 0) > 0 && data.some((item: any) => key in item)
    );
  };

  const hasNewUpload = hasKey(
    getValue(selfCompliance, `document_ids`, []),
    "key",
  );

  useEffect(() => {
    if (autoPopulateSelfComplianceCompletionDate && !getValue(selfCompliance, "completion_date", "")) {
      setSelfCompliance((prev: any) => ({
        ...prev,
        completion_date: new Date(),
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selfCompliance, autoPopulateSelfComplianceCompletionDate]);

  const [reasonMessage, setReasonMessage] = useState("");
  const [commentMessage, setCommentMessage] = useState("");
  const [showReasonAsterisk, setShowReasonAsterisk] = useState(false);
  const [showCommentAsterisk, setShowCommentAsterisk] = useState(false);
  const isLegalDueDatePast = () => {
    const legalDueDate = moment(getValue(selectedObj, "legal_due_date", ""));
    return legalDueDate.isValid() && moment().isAfter(legalDueDate, "day");
  };

  useEffect(() => {
    const completionDate = moment(
      getValue(selfCompliance, "completion_date", ""),
    );
    const legalDueDate = moment(getValue(selectedObj, "legal_due_date", ""));
    const reportedDate = moment();
    const isReasonRequiredForEventNotOccurred =
      getValue(
        selfCompliance,
        "is_required_reason_for_non_compliance",
        false,
      ) &&
      selfCompliance?.event_not_occured &&
      reportedDate.isAfter(legalDueDate, "day");

    if (isReasonRequiredForEventNotOccurred) {
      setReasonMessage(
        "Please provide a reason for Non-Compliance when the event did not occur.",
      );
      setShowReasonAsterisk(true);
      setShowCommentAsterisk(true);
      setCommentMessage(
        "Please provide Evaluator Comments when the event did not occur.",
      );
      setIsBelowMinDate(false);
      setMinDateErrorMessage("");
      return;
    }

    if (!selfCompliance?.event_not_occured) {
      if (!completionDate.isValid() || !legalDueDate.isValid()) {
        setReasonMessage("");
        setCommentMessage("");
        setShowReasonAsterisk(false);
        setShowCommentAsterisk(false);
        setIsBelowMinDate(false);
        setMinDateErrorMessage("");
        return;
      }

      const minThreshold =
        configuredCompletionDate &&
        moment(legalDueDate).subtract(configuredCompletionDate, "days");
      if (
        configuredCompletionDate &&
        minThreshold &&
        completionDate.isBefore(minThreshold, "day")
      ) {
        setIsBelowMinDate(true);
        setMinDateErrorMessage(
          `Completion Date cannot be earlier than ${configuredCompletionDate} days before the Legal Due Date (${(
            minThreshold as any
          ).format("DD MMMM YYYY")}).`,
        );
      } else {
        setIsBelowMinDate(false);
        setMinDateErrorMessage("");
      }

         // ✅ Scenario 1: Delayed
    if (completionDate.isAfter(legalDueDate, "day")) {
      const isReportedAfterDueDate = reportedDate.isAfter(
        legalDueDate,
        "day",
      );

      setShowReasonAsterisk(isReportedAfterDueDate);
      setShowCommentAsterisk(isReportedAfterDueDate);

      setReasonMessage(
        isReportedAfterDueDate
          ? "The Completion Date and current date are greater than legal due date, Please provide a reason for Non-Compliance and the task will go in Delayed Status."
          : "The Completion Date is greater than legal due date, Please provide a reason for Non-Compliance and the task will go in Delayed Status.",
      );

      setCommentMessage(
        isReportedAfterDueDate
          ? "The Completion Date is greater than legal due date, Please provide your comment."
          : "",
      );
    }

    // ✅ Scenario 2: Delayed Reported
    else if (
      completionDate.isSameOrBefore(legalDueDate, "day") &&
      reportedDate.isAfter(legalDueDate, "day")
    ) {
      setShowReasonAsterisk(true);
      setShowCommentAsterisk(false);

      setReasonMessage(
        "Task was completed on time but is being reported after the legal due date, Please provide a reason for Non-Compliance.",
      );

      setCommentMessage("");
    }

    // ✅ Scenario 3: Complied
    else {
      setShowReasonAsterisk(false);
      setShowCommentAsterisk(false);
      setReasonMessage("");
      setCommentMessage("");
    }
  } else {
    setReasonMessage("");
    setCommentMessage("");
    setShowReasonAsterisk(false);
    setShowCommentAsterisk(false);
  }
}, [selfCompliance, selectedObj]);

  const submitTaskWithReasonValidation = (...args: any[]) => {
    const reason = String(
      getValue(selfCompliance, `non_compliance_reason`, "") || "",
    );
    if (reason.trim().length === 0 && showReasonAsterisk) {
      setReasonMessage("Please provide a reason for Non-Compliance.");
      toast.error("Reason for Non-Compliance is required");
      return;
    }
    if (reason.length > 0 && reason.trim().length === 0) {
      setReasonMessage("Reason for Non-Compliance cannot contain only spaces.");
      return;
    }
    handleSubmitTask(...args);
  };
  const submitUploadWithReasonValidation = (...args: any[]) => {
    const reason = String(
      getValue(selfCompliance, `non_compliance_reason`, "") || "",
    );
    if (reason.trim().length === 0 && showReasonAsterisk) {
      setReasonMessage("Please provide a reason for Non-Compliance.");
      toast.error("Reason for Non-Compliance is required");
      return;
    }
    if (reason.length > 0 && reason.trim().length === 0) {
      setReasonMessage("Reason for Non-Compliance cannot contain only spaces.");
      return;
    }
    handleUploadSubmitTask(...args);
  };


  return (
    <div
      className={`compelte-task-wrapper ${
        showUpdatePopup ? "compelte-task-wrapper--active" : ""
      }`}
    >
      <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
        <h6 className="compelte-task-wrapper__title">
          {isCompletionDateEditable ? "Update Task" : "Task Info"}
        </h6>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={() => {
            setShowUpdatePopup(false);
          }}
          alt=""
        />
      </div>
      <div className="compelte-task-wrapper__body d-flex h-100">
        <div className="compelte-task-wrapper__completion compelte-task-wrapper__completion_fixed_button flex-2 padd-0">
          <div className="complete-task-wrapper__completion-holder">
            <div className="compelte-task-wrapper__common-header">
              <h5 className="compelte-task-wrapper__common-title">
                Task Completion
              </h5>
            </div>
            <div className="compelte-task-wrapper__form mt-0">
              <div className="compelte-task-wrapper__form-group mt-0 mb-0 d-flex align-items-center gap">
                {/* {((getValue(props, `type`, "") === "pending_approval" &&
                getValue(props, "selectedIDs.length", 0) === 1) ||
                getValue(props, `type`, "") === "executor-tasks") && ( */}

                {/* {(getValue(props, `type`, "") !== "pending_approval" ||
              (getValue(props, `type`, "") === "pending_approval" &&
                getValue(props, "selectedIDs.length", 0) === 1)) && ( */}
                <div className="form-group cursor-pointer grid mt-0 mb-0">
                  <div className="position-relative input-grid-item">
                    <label className="compelte-task-wrapper__label ms-0 fw-bold">
                      Completion Date
                    </label>
                    <label onClick={(e) => e.preventDefault()} className="ms-0">
                      <InputField
                        inputType="DATETYPE-DOB-MODAL"
                        value={getValue(selfCompliance, `completion_date`, "")}
                        className="form-control"
                        onChange={(e: any) =>
                          setSelfCompliance({
                            ...selfCompliance,
                            completion_date: e,
                            // completion_date: convertDate(e)
                          })
                        }
                        maxDate={
                          futureDateCompletionLimit !== null &&
                          !Number.isNaN(futureDateCompletionLimit)
                            ? moment(
                                getValue(selectedObj, "legal_due_date", "") ||
                                  undefined,
                              )
                                .isValid()
                              ? moment(
                                  getValue(
                                    selectedObj,
                                    "legal_due_date",
                                    "",
                                  ),
                                )
                                  .add(futureDateCompletionLimit, "days")
                                  .endOf("day")
                                  .toDate()
                              : moment()
                                .add(futureDateCompletionLimit, "days")
                                .endOf("day")
                                .toDate()
                            : new Date()
                        }
                        minDate={
                          getValue(selectedObj, "legal_due_date", "") &&
                          configuredCompletionDate
                            ? moment(
                                getValue(selectedObj, "legal_due_date", ""),
                              )
                                .subtract(configuredCompletionDate, "days")
                                .toDate()
                            : null
                        }
                        placeholderText={"Enter Completion Date"}
                        disabled={props?.sub_route === "pending-approval"}
                      />
                      <img
                        src="/images/calander.svg"
                        className="img-fluid form-image form-image--calender-modal"
                        alt=""
                      />
                    </label>
                  </div>
                </div>
                {/* )} */}

                <div className="d-flex mt-3 gap position-relative">
                  <label>
                    <input
                      type="checkbox"
                      className="default-checkbox"
                      checked={getValue(
                        selfCompliance,
                        `event_not_occured`,
                        "",
                      )}
                      disabled={props?.sub_route === "pending-approval"}
                      onChange={(e: any) =>
                        setSelfCompliance({
                          ...selfCompliance,
                          event_not_occured: !getValue(
                            selfCompliance,
                            `event_not_occured`,
                            "",
                          ),
                        })
                      }
                    />
                    <div className="custom-checkbox" >
                      <img
                        src="/images/uploaded-details/tick.svg"
                        className="upload-tick img-fluid"
                        alt=""
                      />
                    </div>
                  </label>
                  <p>Event did not occur</p>
                </div>
              </div>
              {minDateErrorMessage && (
                <Alert color="danger p-1" style={{ fontSize: "12px" }}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">
                      <CautionSvgComponent color={"#DC3545"} />
                    </span>
                    {minDateErrorMessage}
                  </div>
                </Alert>
              )}
              {(checkCompiled() ||
                getValue(props, `type`, "") === "executor-tasks") && (
                <>
                  <div className="compelte-task-wrapper__form-group mt-0">
                    <label className="compelte-task-wrapper__label">
                      Remarks
                    </label>
                    <textarea
                      placeholder="Remarks"
                      className="w-100 compelte-task-wrapper__text-area"
                      rows={3}
                      value={getValue(selfCompliance, `remarks`, "")}
                      onChange={(e: any) =>
                        setSelfCompliance({
                          ...selfCompliance,
                          remarks: sanitizeInput(e.target.value),
                        })
                      }
                    ></textarea>
                  </div>

                  {reasonMessage && (
                    <Alert color="warning p-1" style={{ fontSize: "12px" }}>
                      <div className="d-flex align-items-center">
                        <span className="me-2">
                          <CautionSvgComponent color={"#F5C530"} />
                        </span>
                        {reasonMessage}
                      </div>
                    </Alert>
                  )}
                  <div className="compelte-task-wrapper__form-group">
                    <label className="compelte-task-wrapper__label">
                      Reason for Non-Compliance {showReasonAsterisk && "*"}
                    </label>
                    <textarea
                      placeholder="Enter Reason for Non-Compliance"
                      className="w-100 compelte-task-wrapper__text-area"
                      rows={3}
                      value={getValue(
                        selfCompliance,
                        `non_compliance_reason`,
                        "",
                      )}
                      onKeyDown={(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
                        if (
                          e.key === " " &&
                          e.currentTarget.value.length === 0
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e: any) => {
                        const value = sanitizeInput(e.target.value);
                        setSelfCompliance({
                          ...selfCompliance,
                          non_compliance_reason: value,
                        });
                      }}
                    ></textarea>
                  </div>
                </>
              )}
              {(checkApprover() ||
                getValue(props, `type`, "") === "pending_approval") && (
                <>
                  {commentMessage && (
                    <Alert color="warning p-1" style={{ fontSize: "12px" }}>
                      <div className="d-flex align-items-center">
                        <span className="me-2">
                          <CautionSvgComponent color={"#F5C530"} />
                        </span>
                        {commentMessage}
                      </div>
                    </Alert>
                  )}
                  <div className="compelte-task-wrapper__form-group">
                    <label className="compelte-task-wrapper__label">
                      Evaluator Comments{" "}
                      {(showCommentAsterisk || isLegalDueDatePast()) &&
                        "*"}
                    </label>
                    <textarea
                      placeholder="Enter Evaluator Comments"
                      className="w-100 compelte-task-wrapper__text-area"
                      rows={3}
                      value={getValue(selfCompliance, `evaluator_comments`, "")}
                      onChange={(e: any) =>
                        setSelfCompliance({
                          ...selfCompliance,
                          evaluator_comments: sanitizeInput(e.target.value),
                        })
                      }
                    ></textarea>
                  </div>
                </>
              )}
              {canUpdate && (
                <div className="compelte-task-wrapper__form-group compelte-task-wrapper__label">
                <p className="mb-2">
                  Files Upload{" 	"}
                  {getValue(
                    selectedObj,
                    `self_compliance.document_required`,
                    "",
                  ) && !selfCompliance?.event_not_occured
                    ? "*"
                    : ""}
                </p>
                <DragAndDropFileComponent
                  uploadFile={
                    !uploadLoading ? handleUploadDocuments : disableUpload
                  }
                  name="file"
                  multiple
                  // className="d-none"
                  classes="bulk-upload_drag-n-drop-wrapper position-absolute"
                  fileName={getValue(props, `importedFile.name`, "")}
                  setImportTedFile={props.setImportTedFile}
                />
                {/* <div
                  onDrop={handleDrop}
                  onDragOver={!uploadLoading ? handleDragOver : disableUpload}
                >
                  <p>
                    Files Upload{" 	"}
                    {getValue(
                      selectedObj,
                      `self_compliance.document_required`,
                      ""
                    )
                      ? "*"
                      : ""}
                  </p>
                  <label className="custom-file-upload-popup">
                    {uploadLoading ? (
                      <p>Please wait...</p>
                    ) : (
                      <>
                        <p className="custom-inputfile__attach">
                          Drag & Drop Files here
                        </p>
                        <p className="custom-inputfile__attach">OR</p>
                        <a href="#0">
                          <p className="custom-inputfile__attach">Browse Files</p>
                        </a>
                      </>
                    )}
                    <input
                      type="file"
                      onChange={
                        !uploadLoading ? handleUploadDocuments : disableUpload
                      }
                      multiple
                      className="d-none"
                    />
                  </label>
                </div> */}
                <div className="compelte-task-wrapper__uploaded-files mt-2">
                  <ul>
                    {getValue(selfCompliance, `document_ids`, []).map(
                      (item: any, key: number) => {
                        return (
                          <li className="compelte-task-wrapper__uploaded d-flex align-items-center justify-content-between cursor-pointer py-2">
                            {selectedIndex === key && isLoading ? (
                              <>
                                <span>Downloading...</span>
                                <img
                                  src="/images/close-black.svg"
                                  onClick={() =>
                                    removeDocument(getValue(item, `id`, ""))
                                  }
                                />
                              </>
                            ) : (
                              <>
                                <div className="w-100">
                                  <p
                                    onClick={() =>
                                      !selectedIndex &&
                                      !isLoading &&
                                      handleDownloadOnClick(
                                        getValue(item, `url`, ""),
                                        getValue(item, `name`, ""),
                                        key,
                                      )
                                    }
                                  >
                                    {concatDotToDocumentString(
                                      getValue(item, `name`, ""),
                                    )}
                                    {getValue(item, `extension`, "")}
                                  </p>
                                  {getValue(
                                    item,
                                    `created_by.first_name`,
                                    "",
                                  ) && (
                                    <div className="d-flex align-items-center justify-content-between w-100 mt-2">
                                      <p className="small_text__12 me-2">
                                        Uploded by :{" "}
                                        <span style={{ color: "#1a73e8" }}>
                                          {getValue(
                                            item,
                                            `created_by.first_name`,
                                            "",
                                          )}{" "}
                                          {getValue(
                                            item,
                                            `created_by.last_name`,
                                            "",
                                          )}
                                        </span>
                                      </p>

                                      <p className="small_text__12 ms-2">
                                        Uploaded on :{" "}
                                        <span style={{ fontSize: "12px" }}>
                                          {convertCurrentDate(
                                            getValue(item, `createdAt`, null),
                                          )}
                                        </span>
                                      </p>
                                    </div>
                                  )}
                                </div>
                                {getValue(item, `key`, "") && (
                                  <img
                                    src="/images/close-black.svg"
                                    onClick={() =>
                                      removeDocument(getValue(item, `id`, ""))
                                    }
                                  />
                                )}
                              </>
                            )}
                          </li>
                        );
                      },
                    )}
                    {showUploadUpdate && (
                      <div className="d-flex justify-content-between align-items-center">
                        <div></div>
                        <div className="">
                          <button
                            className="upload_button"
                            onClick={() => handleUpdateUploadDocuments()}
                            disabled={updateUploadLoading || !hasNewUpload}
                          >
                            {updateUploadLoading ? "Please wait..." : "Upload"}
                          </button>

                          <button
                            className="upload_button ms-3"
                            // onClick={() => handleUpdateUploadDocuments()}
                            onClick={() => {
                              handleUpdateUploadDocumentsSubmit();
                              submitUploadWithReasonValidation(
                                getValue(
                                  selfCompliance,
                                  `compliance_status`,
                                  "",
                                ),
                              );
                            }}
                            disabled={updateUploadLoading || !hasNewUpload}
                          >
                            {updateUploadLoading
                              ? "Please wait..."
                              : "Upload & Submit"}
                          </button>
                        </div>
                      </div>
                    )}
                  </ul>
                </div>
              </div>
              )}

              {interlinkedTaskList && interlinkedTaskList.length > 0 && (
                <div className="compelte-task-wrapper__form-group compelte-task-wrapper__label">
                  <p className="mb-2">Interlinked Tasks</p>
                  <div className="">
                    {interlinkedTaskList.map((item: any) => (
                      <div className="mt-2 mb-2">
                        <label key={item.id} className="">
                          <input
                            type="checkbox"
                            checked={selectedInterlinkedTaskIds.includes(
                              item.id,
                            )}
                            onChange={() => handleCheckboxChange(item.id)}
                            disabled={item.task_id === selectedObj.task_id}
                          />
                          <span className="ms-2 text-gray">
                            <span className="text-dark">{item.task_id}</span> -{" "}
                            {
                              item?.self_compliance?.checkpoint
                                ?.compliance_activity
                            }
                          </span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          {showUploadUpdate && isCompletionDateEditable && (
            <div className="compelte-task-wrapper__upload-footer">
              <button
                className="upload_button"
                onClick={() => submitUploadWithReasonValidation("COMPLIED")}
                disabled={submitLoading || updateUploadLoading}
              >
                {submitLoading ? "Please wait..." : "Mark as Complied"}
              </button>
              <button
                className="upload_button upload_button--cancel"
                onClick={() => setShowUpdatePopup(false)}
              >
                Cancel
              </button>
            </div>
          )}
          {canUpdate ? (
            <>
              {checkApprover() ||
              getValue(props, `type`, "") === "pending_approval" ? (
                <>
                  {getValue(props, "sub_route", "") === "pending-approval" ? (
                    // &&
                    // getValue(props, "params.dashboard_type", "") === "EVALUATOR"
                    <div className="compelte-task-wrapper__cta d-flex align-items-center">
                      <button
                        className="ascent-button ascent-button--primary"
                        onClick={() =>
                          submitTaskWithReasonValidation(
                            "RE_OPENED",
                            selectedInterlinkedTaskIds,
                          )
                        }
                        disabled={
                          selectedStatus === "RE_OPENED" && submitLoading
                        }
                      >
                        {selectedStatus === "RE_OPENED" && submitLoading
                          ? "Please wait..."
                          : "Reopen"}
                      </button>
                      <button
                        className="ascent-button ascent-button--secondary"
                        onClick={() =>
                          submitTaskWithReasonValidation(
                            "APPROVED",
                            selectedInterlinkedTaskIds,
                          )
                        }
                        disabled={
                          selectedStatus === "APPROVED" && submitLoading
                        }
                      >
                        {selectedStatus === "APPROVED" && submitLoading
                          ? "Please wait..."
                          : "Approve"}
                      </button>
                    </div>
                  ) : null}
                </>
              ) :
                checkCompiled() &&
                !(showUploadUpdate && isCompletionDateEditable) ? (
                <div className="compelte-task-wrapper__cta d-flex align-items-center">
                  <button
                    className="ascent-button ascent-button--primary"
                    onClick={() => setShowUpdatePopup(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="ascent-button ascent-button--secondary"
                    onClick={() =>
                      submitTaskWithReasonValidation(
                        "COMPLIED",
                        selectedInterlinkedTaskIds,
                      )
                    }
                    disabled={submitLoading || isBelowMinDate}
                  >
                    {submitLoading ? "Please wait..." : "Mark Completed"}
                  </button>
                </div>
              ) : null}
            </>
          ) : null}
          {/* {(getValue(selfCompliance, `compliance_status`, "") === "COMPLIED" ||
            getValue(selfCompliance, `compliance_status`, "") === "DELAYED" ||
            getValue(selfCompliance, `compliance_status`, "") ===
              "EVENT_NOT_OCCURED" ||
            getValue(selfCompliance, `compliance_status`, "") ===
              "AWAITING_APPROVAL" ||
            getValue(selfCompliance, `compliance_status`, "") ===
              "DELAYED_REPORTED") && (
            <div className="compelte-task-wrapper__cta d-flex align-items-center">
              <button
                className="ascent-button ascent-button--secondary"
                onClick={() => handleUpdateUploadDocuments()}
                disabled={updateUploadLoading}
              >
                {updateUploadLoading ? "Please wait..." : "Upload"}
              </button>
            </div>
          )} */}
        </div>
        {/* {getValue(props, `selectedIDs.length`, 0) === 1 
        || getValue(props, `inside`, "") == true  
        &&( */}
        {(getValue(props, "selectedIDs.length", 0) === 1 ||
          getValue(props, "inside", "") === true) && (
          <div className="compelte-task-wrapper__response flex-1">
            <div className="compelte-task-wrapper__common-header">
              <h5 className="compelte-task-wrapper__common-title">
                Task Responses
              </h5>
            </div>
            <div className="compelte-task-wrapper__form ">
              <div className="grid">
                <div className="compelte-task-wrapper__form-group input-grid-item">
                  <InputField
                    inputType="INPUT_REACT_SELECT_MODAL"
                    placeholder="Enter Compliance Status"
                    className="form-control w-100"
                    name="compliance_status"
                    id="compliance_status"
                    value={complianceStatusList.filter(
                      (item: object) =>
                        getValue(item, `value`, "") ===
                        getValue(selfCompliance, `compliance_status`, ""),
                    )}
                    options={complianceStatusList}
                    onChange={(e: any) =>
                      setSelfCompliance({
                        ...selfCompliance,
                        compliance_status: e.value,
                      })
                    }
                    label="Compliance Status"
                    disabled
                  />
                </div>
              </div>
              {showUploadUpdate &&
                getValue(selfCompliance, `compliance_status`, "") !==
                  "REPORTED_NON_COMPLIED" && (
                  <div className="d-flex align-items-center justify-content-between">
                    <div></div>
                    <button
                      onClick={handleChangeUpdateStatus}
                      disabled={statusLoading}
                      className="status_button"
                    >
                      {statusLoading
                        ? "Please wait..."
                        : ' Move to "Reported - Non Complied"'}
                    </button>
                  </div>
                )}

              {/* <div className="d-flex justify-content-between align-items-center mt-2 mb-3">
              <h6>Legal Due Date : </h6>
              <p>{getValue(props, `selectedLegalDueDate`, "")}</p>
            </div> */}

              <div className="compelte-task-wrapper__form-group">
                {(checkApprover() ||
                  getValue(props, `main_route`, "") === "approved-task") &&
                  (getValue(selectedObj, `executor_completion_date`, "") ||
                    getValue(selectedObj, `remarks`, "")) && (
                    <>
                      <div className="popup-margin-bottom">
                        <div className="circle">
                          <p className="text">
                            {getFirstLetter(
                              getValue(selectedObj, `executor.first_name`, ""),
                            )}
                          </p>
                        </div>
                        <div className="mt-2">
                          <h6 className="compelte-task-wrapper__label_popup ">
                            Executor -{" "}
                            {getValue(selectedObj, `executor.first_name`, "") +
                              " " +
                              getValue(selectedObj, `executor.last_name`, "")}
                          </h6>
                          <p className="subtext_popup mb-3">
                            Updated on{" "}
                            {convertCurrentDateWithTime(
                              getValue(
                                selectedObj,
                                `executor_completion_date`,
                                "",
                              ),
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="card p-2 mb-2">
                        <h6 className="compelte-task-wrapper__label_popup ">
                          Remarks
                        </h6>
                        <p className="subtext-header mb-1">
                          {getValue(selectedObj, `remarks`, "")}
                        </p>
                      </div>
                    </>
                  )}
                {(checkCompiled() ||
                  getValue(props, `main_route`, "") === "approved-task") &&
                  (getValue(selectedObj, `evaluator_completion_date`, "") ||
                    getValue(selectedObj, `evaluator_comments`, "")) && (
                    <div className="popup-margin-bottom">
                      <div className="circle">
                        <p className="text">
                          {getFirstLetter(
                            getValue(selectedObj, `evaluator.first_name`, ""),
                          )}
                        </p>
                      </div>
                      <div className="mt-2">
                        <h6 className="compelte-task-wrapper__label_popup ">
                          Evaluator -{" "}
                          {getValue(selectedObj, `evaluator.first_name`, "") +
                            " " +
                            getValue(selectedObj, `evaluator.last_name`, "")}
                        </h6>
                        {/* <p className="subtext_popup mb-2">
                          Updated on{" "}
                          {convertCurrentDateWithTime(
                            getValue(
                              selectedObj,
                              `evaluator_completion_date`,
                              ""
                            )
                          )}
                        </p> */}
                        <p className="subtext_popup mb-2">
                          Approved on{" "}
                          {convertCurrentDateWithTime(
                            getValue(selectedObj, `approved_date`, ""),
                          )}
                        </p>
                        <p className="subtext-header mb-1">
                          {getValue(selectedObj, `evaluator_comments`, "")}
                        </p>
                      </div>
                    </div>
                  )}
                {(checkApprover() ||
                  getValue(props, `main_route`, "") === "approved-task") && (
                  <>
                    {/* {getValue(selfCompliance, `remarks`, "") && (
                    <div className="popup-margin-bottom ">
                      <img
                        src="/images/comments.svg"
                        className="img-fluid"
                        style={{
                          height: "30px",
                          width: "30px",
                          marginRight: "10px",
                        }}
                      />
                      <div className="mt-2 mb-3">
                        <label className="compelte-task-wrapper__label">
                          Remarks
                        </label>
                        <p>{getValue(selfCompliance, `remarks`, "")}</p>
                      </div>
                    </div>
                  )} */}
                    {getValue(selectedObj, `non_compliance_reason`, "") && (
                      // <div className="popup-margin-bottom ">
                      <div className="card p-2">
                        {/* <img
                          src="/images/comments.svg"
                          className="img-fluid"
                          style={{
                            height: "30px",
                            width: "30px",
                            marginRight: "10px",
                          }}
                        /> */}
                        <div className="mt-2">
                          <label className="compelte-task-wrapper__label">
                            Non Compliance Reason
                          </label>
                          <p className="subtext-header">
                            {getValue(selectedObj, `non_compliance_reason`, "")}
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {/* {(checkCompiled() ||
                getValue(props, `main_route`, "") === "approved-task") &&
                getValue(selectedObj, `evaluator_comments`, "") && (
                  <div className="popup-margin-bottom ">
                    <img
                      src="/images/comments.svg"
                      className="img-fluid"
                      style={{
                        height: "30px",
                        width: "30px",
                        marginRight: "10px",
                      }}
                    />
                    <div className="mt-2 mb-3">
                      <label className="compelte-task-wrapper__label">
                        Evaluator Comments
                      </label>
                      <p>{getValue(selectedObj, `evaluator_comments`, "")}</p>
                    </div>
                  </div>
                )} */}

                {
                  <>
                    {getValue(selectedObj, `auditor_comments`, "") && (
                      <div className="popup-margin-bottom ">
                        <img
                          src="/images/comments.svg"
                          className="img-fluid"
                          style={{
                            height: "30px",
                            width: "30px",
                            marginRight: "10px",
                          }}
                        />
                        <div className="mt-2 mb-3">
                          <label className="compelte-task-wrapper__label_popup">
                            Auditor Comments
                          </label>
                          {getValue(
                            selectedObj,
                            `audit_completed_date`,
                            "",
                          ) && (
                            <p className="subtext_popup mb-2">
                              Updated on{" "}
                              {convertCurrentDateWithTime(
                                getValue(
                                  selectedObj,
                                  `audit_completed_date`,
                                  "",
                                ),
                              )}
                            </p>
                          )}
                          <p className="subtext-header mb-1">
                            {getValue(selectedObj, `auditor_comments`, "")}
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                }
              </div>

              {/* {showAuditorComment && ( */}
              <div className="compelte-task-wrapper__form-group">
                <hr />

                {getValue(selectedObj, `audit_comment`, "") && (
                  <div className="card p-2 mt-2 mb-2">
                    <h6 className="compelte-task-wrapper__label_popup">
                      Audit Comments
                    </h6>
                    <p className="subtext-header mb-1">
                      {getValue(selectedObj, `audit_comment`, "")}
                    </p>
                  </div>
                )}
                {/* {!getValue(selectedObj, `audit_comment`, "") && ( */}
                <div className="text-right">
                  <button
                    className="btn btn-primary text-left p-1 "
                    onClick={handleModalAC}
                  >
                    <div className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        width="24"
                      >
                        <path
                          d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z"
                          fill="#ffffff"
                        />
                      </svg>
                      {getValue(selectedObj, `audit_comment`, "")
                        ? "Update Auditor Comment"
                        : "Add Auditor Comment"}
                    </div>
                  </button>
                </div>
                {/* )} */}
              </div>
              {/* )} */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SelfComplianceUpdatePopup;
